import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";

/** Cedulas */
const Cedulas = () => import("@/views/Cedulas/Cedulas.vue");
const Registrar = () => import("@/views/Cedulas/Registrar.vue");
const UpdateCedula = () => import("@/views/Cedulas/Update.vue");
const Editar = () => import("@/views/Cedulas/Editar.vue");
const Show = () => import("@/views/Cedulas/Show.vue");
const Reporte = () => import("@/views/Cedulas/Reporte.vue");
const Roles = () => import("@/views/roles/roles.vue");
const Users = () => import("@/views/Users/User.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Logs = () => import("@/views/logs/log.vue");
const Verificar = () => import("@/views/Cedulas/Verificar.vue");

Vue.use(VueRouter);
/*ROLES
  1 =>  SUPER-ADMIN
  2 =>  ADMIN DEPENDENCIA
  3 =>  CAPTURISTA DEPENDENCIA
  4 =>  VISOR DEPEDENCIA

  CHECAR QUE COICINDAN CON LOS ASIGNADOS EM EL BACKEND
*/
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { authorize: [1, 2, 3, 4] }
  },
  {
    path: "/cedulas",
    name: "Cedulas",
    component: Cedulas,
    meta: { authorize: [1, 2, 3, 4] }
  },
  {
    path: "/verificacion",
    name: "Verificar",
    component: Verificar,
    meta: { authorize: [1, 2, 3, 4, 6] }
  },
  {
    path: "/cedulas/registrar",
    name: "Registrar",
    component: Registrar,
    meta: { authorize: [1, 2, 3] }
  },
  {
    path: "/cedulas/actualizar",
    name: "UpdateCedula",
    component: UpdateCedula,
    meta: { authorize: [1, 2, 3] }
  },
  {
    path: "/cedulas/show/:id",
    name: "Show",
    component: Show,
    props: true,
    meta: { authorize: [1, 2, 3, 4] }
  },
  {
    path: "/cedulas/editar",
    name: "Editar",
    component: Editar,
    meta: { authorize: [1, 2, 3] }
  },
  {
    path: "/cedulas/reportes",
    name: "Reporte",
    component: Reporte,
    meta: { authorize: [1, 2, 3] }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/user/editPassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4] }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/logs",
    name: "Logs",
    component: Logs,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4] }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));

  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.role_id)) {
      if (userLogged.role.role_name = "verificador") {
        return next({ path: "/verificacion" });
      }
      return next({ path: "/cedulas" });
    }
  }
  if ((to.path === "/" || to.path === "/login") && userLogged) {
    return next({ path: "/cedulas" });
  }
  next();
});

export default router;
